 
import React from 'react';
import './../styles/sectioninfo.scss';

const SectionInfo = ({section, page}) => {
    return (
        <div>
            <div className="section-navigation">
                <span className="section-name">{section}</span>
                <span className="section-pagination">{page}/6</span>
            </div>
        </div>
    );
};

export default SectionInfo;
